import React, { useEffect } from 'react';
import { useAuth } from '../../components/navigation/AuthenticationStateManager';
import NavigationTabBar from '../../components/navigation/NavigationTabBar';
import HeroSection from './components/HeroSection';
import StatisticsSection from './components/StatsSection';
import FounderStorySection from './components/FounderStorySection';
import TeamSection from './components/TeamSection';
import MethodologySection from './components/MethodologySection';
import TrustIndicatorsSection from './components/TrustIndicatorsSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import FooterSection from '../../components/navigation/FooterSection';

const AboutPlatform = () => {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <NavigationTabBar isAuthenticated={isAuthenticated} />
      
      <main className="pt-16">
        <HeroSection />
        <StatisticsSection />
        <FounderStorySection />
        {/* <TeamSection /> */}
        <MethodologySection />
        {/* <TrustIndicatorsSection /> */}
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>

      <FooterSection />
    </div>
  );
};

export default AboutPlatform;